import { Plus } from "lucide-react";
import React, { useEffect, useMemo, useState } from "react";
import { decryptToken } from "../utils/getToken";

const TagsSelector = ({ tags = [], onChange, selected }) => {
    const url = process.env.REACT_APP_LINK;
    const token = decryptToken("accessToken") || "";

    const [search, setSearch] = useState("");
    const [localTags, setLocalTags] = useState(tags);
    const [selectedTags, setSelectedTags] = useState(selected || []);


    // Sync selected from parent only if changed
    // useEffect(() => {
    //     if (selected !== selectedTags) {
    //         setSelectedTags(selected);
    //     }
    // }, [selected]);

    useEffect(() => {
        if (Array.isArray(selected)) {
            setSelectedTags(selected);
        }
    }, [selected]);


    // Only fire outbound changes on update
    useEffect(() => {
        onChange?.(selectedTags);
    }, [selectedTags]);

    // Merge + dedupe tags efficiently
    const allTags = useMemo(() => {
        const map = new Map();
        [...tags, ...localTags].forEach((t) => map.set(t.id, t));
        return [...map.values()];
    }, [tags, localTags]);

    // Filter memoized
    const filtered = useMemo(() => {
        return allTags.filter((t) =>
            (t?.name || "").toLowerCase().includes(search.toLowerCase())
        );
    }, [allTags, search]);


    const toggleTag = (tag) => {
        setSelectedTags((prev) =>
            prev.some((t) => t.id === tag.id)
                ? prev.filter((t) => t.id !== tag.id)
                : [...prev, tag]
        );
    };

    const addTag = async () => {
        if (!search.trim()) return;
        if (allTags.some((t) => t.name === search)) return;

        const newTag = { id: Date.now(), name: search };
        setLocalTags((prev) => [...prev, newTag]);
        setSelectedTags((prev) => [...prev, newTag]);
        setSearch("");

        try {
            await fetch(`${url}/tag`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify({ name: newTag.name }),
            });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <h3 className="text-[16px] font-semibold text-black/80">
                Tags
            </h3>

            {/* Search input */}
            <div className="pt-2 mb-3">
                <input
                    type="text"
                    placeholder="Search Tags"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full text-black placeholder-gray-500 border-b-2 border-gray-300 focus:border-indigo-500 outline-none py-2 px-2 transition text-sm"
                />
            </div>

            {/* Tags */}
            <div className="flex flex-wrap gap-2">

                {filtered.length > 0 ? (
                    filtered.map((cat, index) => {
                        const isSelected = selectedTags.some((t) => t.id === cat.id);
                        return (
                            <button
                                key={index}
                                onClick={() => toggleTag(cat)}
                                className={`px-2 py-0.5 text-[12px] rounded-full border transition-all ${isSelected
                                    ? "bg-indigo-500 text-white border-indigo-500"
                                    : "bg-gray-100 text-gray-700 border-gray-200 hover:bg-gray-200"
                                    }`}
                            >
                                {cat.name}
                            </button>
                        );
                    })) : search.trim() ? (
                        <div className="flex flex-col items-center gap-2 w-full">
                            {/* Parent selection */}
                            {/* <select
                                value={newParent}
                                onChange={(e) => setNewParent(e.target.value)}
                                className="w-full border rounded px-2 py-1 text-sm border-dashed border-black text-black hover:bg-blue-50 transition outline-0"
                            >
                                <option value="">No parent</option>
                                {initialCategories.map((cat) => (
                                    <option key={cat.id} value={cat.id}>
                                        {cat.name}
                                    </option>
                                ))}
                            </select> */}

                            {/* Add button */}
                            <button
                                onClick={addTag}
                                className="cursor-pointer flex items-center gap-1 px-3 py-1 text-[12px] rounded-full border border-dashed border-black text-black hover:bg-blue-50 transition"
                            >
                                <Plus size={18} /> Create “{search}”
                            </button>
                        </div>
                    ) : (
                    null
                )}
                {filtered.length === 0 && (
                    <p className="text-gray-400 text-sm">No tags found.</p>
                )}
            </div>
        </>
    );
};

export default TagsSelector;
